import React from "react";
import { FaUpload } from "react-icons/fa";

import "./adminCreateArticle.css";

export default function GalleryImageUpload({
  files,
  onFilesChange,
  inputId = "acaGalleryImages",
  maxFiles = 20,
}) {
  const mergeNewFiles = (fileList) => {
    if (!fileList?.length) return;
    const next = [...files];
    for (let i = 0; i < fileList.length; i += 1) {
      const f = fileList[i];
      if (next.length >= maxFiles) break;
      if (!next.some((x) => x.name === f.name && x.size === f.size)) {
        next.push(f);
      }
    }
    onFilesChange(next);
  };

  return (
    <div className="acaGalleryWrap">
      <input
        id={inputId}
        type="file"
        accept="image/png,image/jpeg,image/gif,image/webp"
        className="acaFileInput"
        multiple
        onChange={(e) => {
          mergeNewFiles(e.target.files);
          e.target.value = "";
        }}
      />
      <label className="acaUploadBox acaGalleryDrop" htmlFor={inputId}>
        <div className="acaUploadInner">
          <div className="acaUploadIcon" aria-hidden="true">
            <FaUpload />
          </div>
          <div className="acaUploadTitle">
            {files.length === 0 ? "Click to upload images" : `Add more images (${files.length} selected)`}
          </div>
          <div className="acaUploadHint">
            PNG, JPG, GIF or WebP — max {maxFiles} in this gallery (20 files total including cover on save)
          </div>
        </div>
      </label>

      {files.length > 0 ? (
        <ul className="acaUploadFileList">
          {files.map((f, i) => (
            <li key={`${f.name}-${f.size}-${i}`} className="acaUploadFileRow">
              <span className="acaUploadFileName" title={f.name}>
                {f.name}
              </span>
              <button
                type="button"
                className="acaUploadRemove"
                onClick={() => onFilesChange(files.filter((_, idx) => idx !== i))}
                aria-label={`Remove ${f.name}`}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
